import { getStore } from "../store/store";

export default (): boolean => {
    return !!getStore().toggleFromWin32;
};
